import React__default from 'react';
import styled from 'styled-components';
import { T as Text } from '../Text/Text-DvcofqkP.js';
import { s as srOnlyMixin } from '../theme/style-mixins/srOnly-D3ByQyko.js';
import { C as CircularProgressBar, g as getSize } from './CircularProgressBar-D7lRW4NS.js';

const MIN_VALUE = 0;
const defaultLabel = clampedValue => /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Text, null, clampedValue, "%"));
const CircularProgressIndicatorContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-p7brml-0"
})(["height:", ";width:", ";display:flex;align-items:center;justify-content:center;"], ({
  $size,
  theme
}) => getSize($size, theme), ({
  $size,
  theme
}) => getSize($size, theme));
const SROnlyProgressBar = /*#__PURE__*/styled('progress').withConfig({
  componentId: "sc-storm-ui-40027066__sc-p7brml-1"
})(["", ""], srOnlyMixin);
const CircularProgressIndicator = ({
  value = 0,
  maxValue = 100,
  size = 'base',
  strokeWidth,
  showLabel = false,
  label = defaultLabel,
  pathColor,
  trailColor,
  strokeLinecap = 'round'
}) => {
  const clampedValue = Math.min(Math.max(value, MIN_VALUE), maxValue);
  return /*#__PURE__*/React__default.createElement(CircularProgressIndicatorContainer, {
    $size: size
  }, /*#__PURE__*/React__default.createElement(CircularProgressBar, {
    value: clampedValue,
    maxValue: maxValue,
    minValue: MIN_VALUE,
    size: size,
    strokeWidth: strokeWidth,
    pathColor: pathColor,
    trailColor: trailColor,
    strokeLinecap: strokeLinecap
  }), /*#__PURE__*/React__default.createElement(SROnlyProgressBar, {
    max: maxValue,
    value: clampedValue,
    "aria-valuemin": 0,
    "aria-valuemax": maxValue,
    "aria-valuenow": clampedValue
  }), /*#__PURE__*/React__default.createElement("div", null, showLabel && (label === null || label === void 0 ? void 0 : label(clampedValue))));
};

export { CircularProgressIndicator as C };
//# sourceMappingURL=CircularProgressIndicator-8HdrmuiR.js.map
